import { operationsAjax } from '../ajax/OperationsAjax'
import { store } from '../state/store'
import { computeShiftId } from './computeShiftId'
import { enqueue } from './queueOps'
import { provisionalPlantId } from './provisionalOperations'
import { isOnlineNow } from './connectivity'

function currentShiftId(): number {
  const { selectedDate, selectedShift } = store.getState().shift
  return computeShiftId(selectedDate, selectedShift)
}

export const operationLocationMutations = {
  async updateOperationLocation(operationId: number, locationId: number) {
    if (isOnlineNow()) return operationsAjax.updateOperationLocation(operationId, locationId)
    // Note: entityId is the operationId so repeated offline location changes for the same machine
    // collapse into one queued mutation (see queueOps dedup) rather than replaying every pick.
    await enqueue({
      entity: 'operationLocation',
      operation: 'update',
      shiftId: currentShiftId(),
      entityId: operationId,
      data: { operationId, locationId, operationPlantId: provisionalPlantId(operationId) },
    })
    return { success: true, data: null }
  },
}
